import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IDataPresignedUrl } from 'src/app/shared/interfaces/get-presigned-url.interface';
import { CustomerDataService } from 'src/app/shared/services/customer-data.service';
import { MoreInfoService } from 'src/app/shared/services/more-info.service';
import { environment } from 'src/environments/environment';

type CacheRequest = {
  request: {
    url: string;
    fileName: string;
    base64Image: string;
  };
  response: any;
};

@Injectable({
  providedIn: 'root'
})
export class GetPresignedUrlService {
  BASE_URL = `${environment.baseUrlBiometric}/biometrics/get-presigned-url`;

  cacheRequest: CacheRequest = {} as CacheRequest;

  private httpOptions = {
    headers: new HttpHeaders({
      'x-adl-transaction-id':
        this.customerService.customerConditionData.transactionId,
      'x-adl-company-id': '0052',
      'x-adl-channel': 'PASIVO',
      'x-adl-biometric-token': '',
      'x-adl-product': 'CDT',
      'x-adl-document-number': this.customerService.customerData.numberDNI,
      'x-adl-document-type': '1',
      Authorization: `Bearer ${this.customerService.customerConditionData.tokenaAuthorization}`
    }),
    params: { 'exclude-interceptor': 'true' }
  };
  constructor(
    private http: HttpClient,
    private moreInfoService: MoreInfoService,
    private customerService: CustomerDataService
  ) {}

  getPresignedUrl(): Observable<HttpResponse<IDataPresignedUrl>> {
    return this.http.get<IDataPresignedUrl>(this.BASE_URL, {
      ...this.httpOptions,
      observe: 'response'
    });
  }

  uploadImage(
    base64Image: string,
    url: string,
    fileName: string
  ): Observable<any> {
    if (
      this.cacheRequest.request &&
      this.isRequestEqualToCache(base64Image, fileName)
    ) {
      return of(this.cacheRequest.response);
    }

    const fileContent = base64Image;
    const blob = new Blob([fileContent], { type: 'text/plain' });
    const file = new File([blob], fileName);
    return this.http
      .put(url, file, {
        observe: 'response',
        params: { 'exclude-interceptor': 'true' }
      })
      .pipe(
        tap((response) => {
          if (response.status === 200) {
            this.cacheRequest.request = {
              base64Image,
              url,
              fileName
            };
            this.cacheRequest.response = response;
          }
          return response;
        })
      );
  }

  isRequestEqualToCache(base64Image: string, fileName: string): boolean {
    return (
      this.cacheRequest.request.fileName === fileName &&
      base64Image === this.cacheRequest.request.base64Image
    );
  }
}
